import React from 'react';
import DoctorDashboard from './DoctorDashboard';

// Re-export the refactored component for backward compatibility
const DoctorDashboardIndex = () => {
  return <DoctorDashboard />;
};

export default DoctorDashboardIndex;
